import { render, staticRenderFns } from "./InputButton.vue?vue&type=template&id=fb57dee8&scoped=true"
import script from "./InputButton.vue?vue&type=script&lang=js"
export * from "./InputButton.vue?vue&type=script&lang=js"
import style0 from "./InputButton.vue?vue&type=style&index=0&id=fb57dee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb57dee8",
  null
  
)

export default component.exports